import { gql } from '@apollo/client';

const LIST_COMPANY_ACCOUNTAPPLICATIONS = gql`
query listCompanyAccountApplications($companyId: Int!){
	companyAdminContext{
		users{
			accountApplications(companyId: $companyId){
				contact
				created
				id
				email
			}
		}
	}
}`;

export default LIST_COMPANY_ACCOUNTAPPLICATIONS;